<template>
  <div
      v-loading="loading"
      class="order-return-summary flex flex-auto flex-col">
    <div class="title">
      Return #{{ returnId }} has been created.
    </div>
    
    <div
        v-if="needsReturnLabel || needsReturnLabel === null"
        class="description description-title-fix">
      Return label has been generated and sent to the customer.<br>
      Once the devices are received by Ring, funds will be returned by the <br>
      original payment method.
    </div>
    <div
        v-else
        class="description description-no-label">
      The customer does not need to return the product(s), therefore no return label will be sent.
    </div>
    <br>
    <!--<div class="return-summary">-->
    <el-card
        shadow="never"
        body-style="margin: 0px !important;">
      <el-table
          :data="summary"
          :show-header="false"
          class="table-hover"
          row-class-name="table-hover"
          cell-class-name="table-hover"
          :highlight-current-row="false"
          style="width: 100%">
        <el-table-column
            type="expand">
          <template>
            <div class="return-details">
              <div class="flex flex-col">
                <div
                    class="summary-header">
                  Items
                </div><br>
                <div
                    v-for="(item, idx) in itemsToReturn"
                    :key="idx"
                    v-bind="item">
                  x{{ item.quantity }} {{ item.title }}<br>
                  <p style="color: #6E6E6E; margin: 0 !important;">
                    ASIN: {{ item.sku }}
                  </p>
                </div>
                <el-divider />
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Customer info
                  </div><br>
                </div>
                <div class="flex flex-col">
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Name
                    </div>
                    <div>{{ customer.customer_name }}</div>
                  </div>
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Phone Number
                    </div>
                    <div>{{ customer.customer_phone }}</div>
                  </div>
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Email
                    </div>
                    <div>{{ customer.customer_email }}</div>
                  </div>
                  <div
                      class="flex flex-row"
                      style="margin-top: 20px">
                    <div class="flex-1">
                      Street
                    </div>
                    <div>{{ address.address_1 }} {{ address.address_2 }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      City
                    </div>
                    <div>{{ address.city }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      State/province/area
                    </div>
                    <div>{{ address.state }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      Zip code
                    </div>
                    <div>{{ address.zip }}</div>
                  </div>
                  <div
                      class="flex flex-row">
                    <div class="flex-1">
                      Country
                    </div>
                    <div>{{ address.country }}</div>
                  </div>
                </div>
                <el-divider />
                <div class="flex flex-col">
                  <div
                      class="summary-header">
                    Payments
                  </div><br>
                </div>
                <div class="flex flex-col">
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Amount
                    </div>
                    <div>{{ refundInfo.amount }}</div>
                  </div>
                  <div class="flex flex-row">
                    <div class="flex-1">
                      Currency
                    </div>
                    <div>{{ refundInfo.currency }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Return details"
            prop="title" /><label>Return Details
            </label>
      </el-table>
    </el-card>
    <!--</div>-->
  </div>
</template>
<script>
import numeral from "numeral";
import axios from "axios";

export default {
  name: "ReturnSummary",
  props: {
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          customer_email: "",
          customer_name: "",
          customer_phone: "",
        };
      },
    },
    address: {
      type: Object,
      required: true,
      default() {
        return {
          address_1: "",
          address_2: "",
          city: "",
          country: "",
          state: "",
          zip: "",
        };
      },
    },
    refundPaymentInfo: {
      type: Object,
      required: true,
      default() {
        return {
          stateTax: 0,
          additionalFees: 0,
          totalRefund: 0,
          currency: "USD",
        };
      },
    },
    refundInfo: {
      type: Object,
      required: true,
      default() {
        return {
          amount: 200,
          currency: "USD",
        };
      },
    },
    returnId: {
      type: String,
      required: true,
      default: "",
    },
    itemsToReturn: {
      type: Array,
      required: true,
    },
    needsReturnLabel: {
      type: [Boolean, null],
      default: true, // Optional prop, defaults to null if not passed
    },
  },
  data() {
    return {
      currencySymbols: {
        EUR: "€",
        NONE: "",
        USD: "$",
        GBP: "£",
        AUD: "A$",
        NZD: "N$",
        CAD: "C$",
      },
      summary: [
        {
          type: "expand",
          title: "Return details",
        },
      ],
      loading: false,
    };
  },
  watch: {},
  methods: {
    formattedAmount(amount, currency) {
      var neg = false;
      if (amount < 0) {
        neg = true;
        amount = -amount;
      }

      amount = numeral(amount).format(`0,0.00`);
      return `${neg ? "– " : ""}${
        this.currencySymbols[currency || "USD"]
      }${amount}`;
    },
  },
};
</script>

<style>
.order-return-summary {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }

  .return-details {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 10px;
    color: #424242;
  }

  .edit-details-link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    text-decoration-line: underline;
    color: #1476ad;
  }
}

.summary-header {
  width: 939px;
  height: 24px;

  /* body/large-medium */

  font-family: "Equip";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: flex-end;

  /* 🖥 light/content/base */

  color: #424242;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}
.el-table__expanded-cell[class*="cell"] {
  padding: 20px !important;
  line-height: initial;
}
.el-table td.el-table__cell div {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: inherit !important;
}

.order-return-summary .description-no-label {
  color: red !important;
}
.order-return-summary .description-title-fix {
  display: block !important;
  margin: 0 0 60px;
}
</style>
